import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import config from 'config';

export default class GraphicImpression extends PureComponent {
  static propTypes = {
    id: PropTypes.number.isRequired,
    id2: PropTypes.string.isRequired, // Extended ID (Concatenation of:Document No-Document Version No-Parent Document No-Parent Document Version No)
    name: PropTypes.string.isRequired,
    creative: PropTypes.string.isRequired,
    sectionTitle: PropTypes.string, // section title is used in responsive Webshop only on logged out home page
    position: PropTypes.string.isRequired,
  };

  static contextTypes = {
    recordGraphicImpression: PropTypes.func,
  };

  componentDidMount() {
    this.recordGraphicImpression();
  }

  componentDidUpdate() {
    this.recordGraphicImpression();
  }

  recordGraphicImpression = () => {
    const { recordGraphicImpression } = this.context;

    if (!config.isServer && !recordGraphicImpression) {
      console.error(// eslint-disable-line no-console
        'recordGraphicImpression not available in context,' +
        ' have you used <GraphicImpressionsContainer> in component tree?'
      );
    }

    if (recordGraphicImpression) {
      const id = this.props.id ? `${this.props.id}` : null;
      const {
        name,
        creative,
        sectionTitle,
        position,
        id2,
      } = this.props;
      recordGraphicImpression({ id, id2, name, creative, sectionTitle, position });
    }
  };

  render = () => null;
}
